<template>
  <svg width="160" height="24" viewBox="0 0 160 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4304_5525)">
      <path d="M9.98772 12.7952L0 0L9.98215 0.200534L9.98772 12.7952Z" fill="#5FC3C2" />
      <path d="M9.99053 21.5381L4.16669 19.5383L9.99053 14.8926V21.5381Z" fill="white" />
      <path d="M10.7982 0.178223L24.7855 14.7643L10.8066 21.6799L10.7982 0.178223Z" fill="white" />
      <path d="M28.6903 3.90771L25.1531 13.9706L18.3182 6.8461L28.6903 3.90771Z" fill="white" />
      <path d="M31.9963 6.55909L28.668 6.42262L29.4897 4.08862L31.9963 6.55909Z" fill="white" />
      <path d="M9.67034 22.2898L2.71292 24L3.68774 20.2344L9.67034 22.2898Z" fill="white" />
      <path
        d="M44.1881 17.434L39.0773 10.3373V17.434H36.7962V6.55225H39.1441L44.1101 13.3871V6.55225H46.3912V17.434H44.1881Z"
        fill="white"
      />
      <path
        d="M50.2487 12C50.2487 8.7218 52.6106 6.37109 55.8414 6.37109C59.0722 6.37109 61.4508 8.7218 61.4508 12C61.4508 15.2782 59.0889 17.6289 55.8414 17.6289C52.5939 17.6289 50.2487 15.2809 50.2487 12ZM59.1056 12C59.1056 9.96121 57.8189 8.42657 55.8442 8.42657C53.8695 8.42657 52.5966 9.96121 52.5966 12C52.5966 14.0387 53.8667 15.5734 55.8442 15.5734C57.8217 15.5734 59.1056 14.0248 59.1056 12Z"
        fill="white"
      />
      <path
        d="M67.9906 17.434L63.8435 6.55225H66.4476L69.4222 14.9218L72.3801 6.55225H74.9843L70.8538 17.434H67.9934H67.9906Z"
        fill="white"
      />
      <path
        d="M84.8659 17.434L84.2058 15.5902H79.6103L78.9363 17.434H76.3321L80.4793 6.55225H83.3396L87.4701 17.434H84.8659ZM81.9081 8.86953L80.2369 13.5514H83.5792L81.9081 8.86953Z"
        fill="white"
      />
      <path
        d="M92.1631 17.434V8.59101H89.0297V6.55225H97.5803V8.59101H94.4608V17.434H92.1631Z"
        fill="white"
      />
      <path
        d="M100.391 12C100.391 8.7218 102.753 6.37109 105.983 6.37109C109.214 6.37109 111.593 8.7218 111.593 12C111.593 15.2782 109.231 17.6289 105.983 17.6289C102.736 17.6289 100.391 15.2809 100.391 12ZM109.248 12C109.248 9.96121 107.961 8.42657 105.986 8.42657C104.012 8.42657 102.739 9.96121 102.739 12C102.739 14.0387 104.009 15.5734 105.986 15.5734C107.964 15.5734 109.248 14.0248 109.248 12Z"
        fill="white"
      />
      <path
        d="M121.511 17.434L119.405 13.5682H117.734V17.434H115.453V6.55225H120.466C122.7 6.55225 124.068 8.03676 124.068 10.0588C124.068 12.0809 122.878 13.0111 121.722 13.2896L124.134 17.434H121.514H121.511ZM121.736 10.0588C121.736 9.14526 121.046 8.59101 120.129 8.59101H117.734V11.5266H120.129C121.046 11.5266 121.736 10.9724 121.736 10.0588Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4304_5525">
        <rect width="124.135" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
